import { CreateOrReadResponseBody } from ".";
import {
  DELETE_IP_PHONE_TRANSCRIPT_PATH,
  GET_IP_PHONE_SETTINGS_PATH,
  GET_IP_PHONE_TOKEN_PATH,
  GET_IP_PHONE_TRANSCRIPTS_PATH,
  IP_PHONE_API_BASE_URL,
  IP_PHONE_MEMBERS_PATH,
} from "../constant";
import { createRequest, getJson, putJson } from "../utils/network";

export type GetIpPhoneTokenResponse = CreateOrReadResponseBody<string>;

export type PostEventLog = {
  event_type: string;
  identity: string;
  room_name: string;
  description: any;
  date: string;
};

export type PostIpPhoneTokenResponse = CreateOrReadResponseBody<PostEventLog>;

export async function fetchIpPhoneToken(workspaceId: number) {
  const { response } = await getJson<GetIpPhoneTokenResponse>(GET_IP_PHONE_TOKEN_PATH, { workspaceId });

  if (response.success) {
    return response.data;
  } else {
    return null;
  }
}

export async function getIpPhoneEventLogs<T>(token: string, search?: string): Promise<T | null> {
  let url = IP_PHONE_API_BASE_URL + "/event-log";

  if (search) {
    url += `?search=${search}`;
  }

  const res = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  const response = await res.json();

  if (response) {
    return response;
  } else {
    return null;
  }
}

export async function postIpPhoneEventLog(postEventLog: PostEventLog, token: string) {
  const res = await fetch(IP_PHONE_API_BASE_URL + "/event-log", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(postEventLog),
  });

  const response = await res.json();

  if (response) {
    return response;
  } else {
    return null;
  }
}

export async function getIpPhoneTranscripts(workspaceId?: number, page?: number, tags?: string) {
  const params = { workspaceId, page, tags };

  const { response } = await getJson(GET_IP_PHONE_TRANSCRIPTS_PATH, params);

  if (response.success) {
    return response.data;
  } else {
    alert(response.errors[0].message);
  }
}

export async function deleteIpPhoneTranscript(transcriptId: number, workspaceId?: number) {
  const { response } = await createRequest(DELETE_IP_PHONE_TRANSCRIPT_PATH(transcriptId), {
    method: "DELETE",
    body: JSON.stringify({
      workspaceId,
    }),
  });

  if (response.success) {
    return response.data;
  } else {
    throw new Error(`Error when deleting transcript report: ${JSON.stringify(response.errors)}`);
  }
}

export async function getIpPhoneSettings(workspaceId: number) {
  const params = { workspaceId };

  const { response } = await getJson(GET_IP_PHONE_SETTINGS_PATH, params);

  if (response.success) {
    return response.data;
  } else {
    alert(response.errors[0].message);
  }
}

export async function getIpPhoneMembers(workspaceId: number) {
  const params = { workspaceId };

  const { response } = await getJson(IP_PHONE_MEMBERS_PATH, params);

  if (response.success) {
    return response.data;
  } else {
    alert(response.errors[0].message);
  }
}

export async function updateIpPhoneMember(workspaceId: number, userId: number, phoneNumber: string) {
  const params = { workspaceId, userId, phoneNumber };

  const { response } = await putJson(IP_PHONE_MEMBERS_PATH, params);

  if (response.success) {
    return response.data;
  } else {
    alert(response.errors[0].message);
  }
}
